import React, {useState} from 'react';
import CustomBottomSheet from 'components/bottomSheet';
import DeleteForm from './deleteForm';
import ButtonGroups from './buttonGroup';
import RregisteredOffers from './RregisteredOffersAuction';
import RregisteredOffersPrepayment from './RregisteredOffersPrepayment';
import ChooseRregisteredOffers from './ChooseRregisteredOffers';

interface ButtonPrepaymentProps {
  app: 'farm' | 'wholesaler';
  guid: string;
  type: string;
  postType: string;
  chosedSugestionUser: IChosedSugestionUser;
  isExpired: boolean;
  is_saled: boolean;
  setChosedSugestionUser: (chosedSugestionUser: IChosedSugestionUser) => void;
  setisOpenEndModal: (isOpenEndModal: boolean) => void;
}
const ButtonPrepayment = ({
  app,
  guid,
  postType,
  type,
  isExpired,
  is_saled,
  chosedSugestionUser,
  setChosedSugestionUser,
  setisOpenEndModal,
}: ButtonPrepaymentProps) => {
  const [isDeleteModalOpen, setisDeleteModalOpen] = useState<boolean>(false);
  const [isOpenOfferAuction, setIsOpenOfferAuction] = useState<boolean>(false);
  const [isOpenOfferPrepayment, setIsOpenOfferPrepayment] =
    useState<boolean>(false);
  return (
    <>
      <ButtonGroups
        guid={guid}
        is_saled={is_saled}
        postType={postType}
        isOpenOffer={isOpenOfferAuction}
        isDeleteModalOpen={isDeleteModalOpen}
        isOpenOfferPrepayment={isOpenOfferPrepayment}
        setIsOpenOfferPrepayment={setIsOpenOfferPrepayment}
        setIsOpenOfferAuction={setIsOpenOfferAuction}
        setisDeleteModalOpen={setisDeleteModalOpen}
      />

      <CustomBottomSheet
        isOpen={isDeleteModalOpen}
        onDismiss={() => setisDeleteModalOpen(false)}
      >
        <DeleteForm
          is_saled={is_saled}
          postType={postType}
          guid={guid}
          app={app}
          isOpen={isDeleteModalOpen}
          setChosedSugestionUser={setChosedSugestionUser}
          setIsopen={setisDeleteModalOpen}
        />
      </CustomBottomSheet>
      <CustomBottomSheet
        isOpen={isOpenOfferAuction}
        onDismiss={() => setIsOpenOfferAuction(false)}
      >
        <RregisteredOffers
          is_saled={is_saled}
          guid={guid}
          postType={type}
          setIsOpenOfferAuction={setIsOpenOfferAuction}
        />
      </CustomBottomSheet>
      <CustomBottomSheet
        isOpen={isOpenOfferPrepayment}
        onDismiss={() => setIsOpenOfferPrepayment(false)}
      >
        <RregisteredOffersPrepayment
          postType={type}
          guid={guid}
          setIsOpenOfferPrepayment={setIsOpenOfferPrepayment}
        />
      </CustomBottomSheet>
      <CustomBottomSheet
        isOpen={chosedSugestionUser.isOpenModal}
        onDismiss={() => {
          isExpired && setisOpenEndModal(true);
          setChosedSugestionUser({
            isOpenModal: false,
            profile: null,
            type: null,
            guid: null,
            isDelete: false,
          });
        }}
      >
        <ChooseRregisteredOffers
          is_saled={is_saled}
          type={postType}
          postType={type}
          isExpired={isExpired}
          chosedSugestionUser={chosedSugestionUser}
          setisOpenEndModal={setisOpenEndModal}
          setChosedSugestionUser={setChosedSugestionUser}
        />
      </CustomBottomSheet>
    </>
  );
};

export default ButtonPrepayment;
